import { useMemo } from 'react';
import { FlowNodes } from '../FlowNodes';
import dagre from 'dagre';

export const useReactFlowData = (items, nodeElementType, childrenNodeKey = 'children') => {
    return useMemo(() => {
        if (!items?.length) return { nodes: [], edges: [] };

        const NODE_WIDTH = 280;
        const NODE_HEIGHT = 50;

        const nodes = [];
        const edges = [];
        const itemMap = new Map();

        // 1. Crea nodi
        items.forEach((item) => {
            const nodeId = item._id;
            itemMap.set(item._id, nodeId);

            nodes.push({
                id: nodeId,
                position: { x: 0, y: 0 },
                data: {
                    label: <FlowNodes type={nodeElementType} item={item} />,
                    item: item
                },
                type: 'default',
                style: { 
                    width: NODE_WIDTH+'px'
                }
            });
        });

        // 2. Crea edges per gerarchia diretta
        items.forEach((item) => {
            const sourceNodeId = itemMap.get(item._id);

            (item[childrenNodeKey] ?? [])?.forEach((child) => {
                const targetNodeId = itemMap.get(child._id);
                if (targetNodeId) {
                    edges.push({
                        id: `edge-${sourceNodeId}-${targetNodeId}`,
                        source: sourceNodeId,
                        target: targetNodeId,
                        type: 'smoothstep'
                    });
                }
            });
        });

        // 3. Layouting con Dagre
        const dagreGraph = new dagre.graphlib.Graph();
        dagreGraph.setDefaultEdgeLabel(() => ({}));

        // Aggiungi nodi al grafo Dagre con dimensioni fisse
        nodes.forEach(node => {
            dagreGraph.setNode(node.id, {
                width: NODE_WIDTH,
                height: NODE_HEIGHT
            });
        });

        // Calcola altezza massima per ranksep dinamico
        let maxHeight = NODE_HEIGHT;
        nodes.forEach(node => {
            const nodeData = dagreGraph.node(node.id);
            maxHeight = Math.max(maxHeight, nodeData.height);
        });

        dagreGraph.setGraph({
            rankdir: 'TB',
            nodesep: 150,
            ranksep: 180, //maxHeight + 100 // Spazio extra tra livelli
        });

        // Aggiungi edges al grafo Dagre
        edges.forEach(edge => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        // Calcola layout
        dagre.layout(dagreGraph);

        // Applica posizioni calcolate
        const layoutedNodes = nodes.map(node => {
            const { x, y } = dagreGraph.node(node.id);
            return { ...node, position: { x, y } };
        });

        return {
            nodes: layoutedNodes,
            edges
        };
    }, [items, nodeElementType]);
};